export default __webpack_public_path__ + "static/media/gps.a8b2c944.svg";